<script lang="ts">
	const TIMEOUT_MS = 8000;
	const TRANSITION_MS = 100;

	export let boardName: string;
	export let prefix: string = 'Pinned to';

	export const open = (newPrefix: string, callback?: () => void) => {
		const notification = document.getElementById('undoable-action-notification');
		if (!notification) {
			return;
		}
		prefix = newPrefix;
		undoCallback = callback;
		notification.style.visibility = 'visible';
		notification.style.opacity = '1';
		clearTimeout(lastTimeout);
		lastTimeout = setTimeout(() => {
			notification.style.opacity = '0';
			setTimeout(() => {
				notification.style.visibility = 'hidden';
			}, TRANSITION_MS);
		}, TIMEOUT_MS);
	};

	export const close = () => {
		const notification = document.getElementById('undoable-action-notification');
		if (!notification) {
			return;
		}
		notification.style.opacity = '0';
		setTimeout(() => {
			notification.style.visibility = 'hidden';
			undoCallback = undefined;
			clearTimeout(lastTimeout);
		}, TRANSITION_MS);
	};

	let lastTimeout: NodeJS.Timeout | undefined = undefined;
	let undoCallback: (() => void) | undefined = undefined;
</script>

<div
	id="undoable-action-notification"
	class="fixed bottom-4 left-1/2 w-fit py-2 px-4 flex flex-row justify-center items-center text-xs rounded border shadow-lg
	text-zinc-900 bg-primary-50 border-primary-200
	dark:text-zinc-200 dark:bg-zinc-800 dark:border-zinc-700"
	style="transform: translateX(-50%)"
>
	<div class="w-24 text-left">
		{prefix + ' '}<b>{boardName}</b>
	</div>
	{#if undoCallback !== undefined}
		<div class="w-2"></div>
		<button
			class="p-3 font-semibold rounded border
			bg-primary-200 border-primary-200 text-zinc-900 hover:brightness-90
			dark:bg-zinc-700 dark:border-zinc-600 dark:text-zinc-200 dark:hover:brightness-125"
			on:click={() => {
				undoCallback?.();
				close();
			}}
		>
			Undo
		</button>
	{/if}
</div>

<style>
	#undoable-action-notification {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.1s ease-in-out;
	}
</style>
